<template>
  <div v-if="verifiedEvents && verifiedEvents.length">
    <v-chip
      small
      v-for="(event, index) in verifiedEvents"
      :key="index"
      :close="close"
      @click:close="handleRemove(event)"
      class="event-chip pa-1 ma-1 mb-1"
    >
      {{ event.text }}
    </v-chip>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

const EMITTED_ACTIONS = {
  REMOVE: "remove",
};

export default {
  name: "VerifiedEventsDisplay",
  props: {
    value: {
      type: Object,
      required: true,
    },
    close: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    verifiedEvents() {
      if (!this.value) {
        return;
      }
      const arr = [];

      if (lodashGet(this.value, "type") === "maritime") {
        arr.push({
          type: "maritime",
          categories: null,
          text: `Verified Events: Maritime`,
        });
      } else if (lodashGet(this.value, "type") === "security") {
        if (
          lodashGet(this.value, "categories") &&
          this.value.categories.length
        ) {
          this.value.categories.forEach((cat) => {
            arr.push({
              id: cat,
              type: "security",
              categories: this.value.categories,
              text: `Verified Events: Security (${cat})`,
            });
          });
        }
      }
      return arr;
    },
  },
  methods: {
    handleRemove(item) {
      if (!item || !item.type) {
        return;
      }
      if (item.type === "security") {
        const categories = this.value.categories;
        const INDEX = categories.indexOf(item.id);
        this.value.categories.splice(INDEX, 1);
      }
      this.$emit(EMITTED_ACTIONS.REMOVE, item);
    },
  },
};
</script>

<style scoped>
.event-chip >>> .v-chip__content {
  height: 24px;
  border-radius: 16px;
  padding: 0 6px;
}
</style>
